module.exports = __webpack_public_path__ + "static/media/Galeria_Familiares_5.747bc9f8.jpg";